// subject_types marketing_campaigns_module raises tickets under — see
// the contact-ticket raiser (campaign_contact, one per contact per campaign)
// and the older engagement / bounce / call-step raisers, whose open tickets
// remain until worked.
// Duplicated from the backend rather than generated (no shared enum exists;
// TicketsPage.tsx keeps its own copy for a different purpose — filtering the
// dedicated campaign-tickets box, not labeling).
const CAMPAIGN_TICKET_SUBJECT_TYPES = new Set([
  "campaign_contact",
  "campaign",
  "campaign_engaged",
  "campaign_bounce",
]);

/**
 * The campaign name for a campaign-raised ticket, or null for any other
 * ticket. Campaign-raised tickets carry their campaign's name in
 * `subject_label` (set by the raising action) but not in `title` — several
 * tickets about the same contact then read identically at a glance (e.g.
 * repeat "Engaged — Paul Bennett" rows for different campaigns) unless the
 * campaign name is surfaced separately, as this helper does.
 */
export function campaignTicketLabel(ticket: {
  subject_type?: string | null;
  subject_label?: string | null;
}): string | null {
  if (!CAMPAIGN_TICKET_SUBJECT_TYPES.has(ticket.subject_type ?? "")) {
    return null;
  }
  return ticket.subject_label ?? null;
}
